import { formatDrawingLocation } from "./drawingStructureApi";
import { DEFAULT_DRAWING_KIND } from "./drawingKinds";

export const isAndreDrawing = (item) =>
  !(item?.drawing_floor?.id || item?.drawing_floor_id);

const houseIdOf = (item) => {
  const id =
    item?.drawing_floor?.drawing_house?.id ||
    item?.drawing_house_id ||
    item?.house_id;
  if (id != null) return String(id);
  const name = item?.drawing_floor?.drawing_house?.name || item?.house || "";
  return name ? `name:${name}` : "unknown-house";
};

const houseNameOf = (item) =>
  item?.drawing_floor?.drawing_house?.name || item?.house || "";

const floorIdOf = (item) => {
  const id = item?.drawing_floor?.id || item?.drawing_floor_id;
  return id != null ? String(id) : "";
};

const floorNameOf = (item) => item?.drawing_floor?.name || item?.floor || "";

export const drawingMatchesQuery = (item, query) => {
  const q = String(query || "").trim().toLowerCase();
  if (!q) return true;
  const { house, floor } = formatDrawingLocation(item);
  const hay = [
    item?.title,
    item?.displayTitle,
    house,
    floor,
    item?.drawing_kind,
    item?.id,
  ]
    .filter((value) => value != null && value !== "")
    .join(" ")
    .toLowerCase();
  return hay.includes(q);
};

export const filterDrawingsForMobileMenu = (
  drawings,
  { query = "", kind = null } = {},
) =>
  (drawings || []).filter((item) => {
    if (kind && (item?.drawing_kind || DEFAULT_DRAWING_KIND) !== kind) {
      return false;
    }
    return drawingMatchesQuery(item, query);
  });

export const groupDrawingsByStructure = (drawings) => {
  const houseMap = new Map();
  const andre = [];

  (drawings || []).forEach((item) => {
    if (isAndreDrawing(item)) {
      andre.push(item);
      return;
    }

    const houseId = houseIdOf(item);
    if (!houseMap.has(houseId)) {
      houseMap.set(houseId, {
        id: houseId,
        name: houseNameOf(item),
        floors: new Map(),
      });
    }

    const house = houseMap.get(houseId);
    const floorId = floorIdOf(item) || "unknown-floor";
    if (!house.floors.has(floorId)) {
      house.floors.set(floorId, {
        id: floorId,
        name: floorNameOf(item),
        items: [],
      });
    }
    house.floors.get(floorId).items.push(item);
  });

  return {
    houses: Array.from(houseMap.values()).map((house) => ({
      id: house.id,
      name: house.name,
      floors: Array.from(house.floors.values()),
    })),
    andre,
  };
};

export const canShowDrawing3dFab = ({
  companyHasIfcModule,
  userHasIfcRole,
  projectId,
}) => Boolean(companyHasIfcModule && userHasIfcRole && projectId);

export const structureKeysForDrawing = (item) => {
  if (!item || isAndreDrawing(item)) {
    return { houseId: null, floorId: null };
  }
  return {
    houseId: houseIdOf(item),
    floorId: floorIdOf(item) || null,
  };
};
